import React from 'react'
import {
  ContainerPricingModel,
  Product,
} from '../../../../modules/productsListing/types'
import { FormikProps, useFormikContext } from 'formik'
import { PrivateOffer } from '../../../../modules/privateOffer/types'
import { BoxV4 } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShelves } from '@fortawesome/pro-regular-svg-icons'

import { AdditionalUsageDimensionsV2 } from '../../../../common/components/AdditionalUsageDimensionsV2/AdditionalUsageDimensionsV2'

export type PrivateOfferUsageDimensionsProps = {
  product: Product
}
export const PrivateOfferUsageDimensions: React.FC<
  PrivateOfferUsageDimensionsProps
> = ({ product }) => {
  const formikProps = useFormikContext() as FormikProps<PrivateOffer>
  const shouldShowDescription =
    product?.containerPricingModel !== ContainerPricingModel.HOURLY

  return (
    <div data-testid="usage-Dimensions-section">
      <BoxV4
        heading={'Usage dimensions'}
        headingIcon={
          <FontAwesomeIcon
            icon={faShelves}
            style={{ width: '18px', height: '14px' }}
          />
        }
      >
        <AdditionalUsageDimensionsV2
          formik={
            formikProps as unknown as FormikProps<Record<string, unknown>>
          }
          dimensionsHeadingName={'Display name'}
          shouldShowDescription={shouldShowDescription}
          inputFieldTitle={'Enter price'}
        />
      </BoxV4>
    </div>
  )
}
